import countryPhotos from "./country-photos.json";

/** Mountain / landscape heroes for country pages. Local paths preferred. */
export const COUNTRY_HEROES: Record<string, string> = {
  "austria": "/images/highlights/paragliding-koessen.jpg",
  "belarus": "/images/highlights/forest-bialowieza-belarus-edge.jpg",
  "belgium": "/images/highlights/belgium-ardennes.jpg",
  "bosnia-and-herzegovina": "/images/highlights/rafting-drina.jpg",
  "brazil": "/images/countries/brazil.jpg",
  "bulgaria": "/images/highlights/bulgaria-rila.jpg",
  "canada": "/images/countries/canada.jpg",
  "chile": "/images/countries/chile.jpg",
  "china": "/images/countries/china.jpg",
  "colombia": "/images/countries/colombia.jpg",
  "croatia": "/images/highlights/trail-plitvice.jpg",
  "czech-republic": "/images/highlights/trail-krkonose.jpg",
  "england": "/images/highlights/england-yorkshire-dales.jpg",
  "france": "/images/highlights/climbing-verdon.jpg",
  "germany": "/images/highlights/climbing-frankenjura.jpg",
  "greece": "/images/highlights/climbing-kalymnos.jpg",
  "hungary": "/images/highlights/lake-balaton.jpg",
  "iceland": "/images/highlights/iceland-golden-circle.jpg",
  "ireland": "/images/highlights/ireland-donegal.jpg",
  "italy": "/images/highlights/climbing-arco.jpg",
  "japan": "/images/countries/japan.jpg",
  "kenya": "/images/countries/kenya.jpg",
  "mexico": "/images/countries/mexico.jpg",
  "montenegro": "/images/highlights/montenegro-durmitor.jpg",
  "morocco": "/images/countries/morocco.jpg",
  "netherlands": "/images/highlights/netherlands-hoge-veluwe.jpg",
  "north-macedonia": "/images/highlights/lake-ohrid.jpg",
  "norway": "/images/highlights/norway-lofoten.jpg",
  "poland": "/images/highlights/forest-bialowieza.jpg",
  "portugal": "/images/highlights/paragliding-madeira.jpg",
  "romania": "/images/highlights/trail-retezat.jpg",
  "russia": "/images/countries/russia.jpg",
  "scotland": "/images/highlights/trail-west-highland.jpg",
  "slovakia": "/images/highlights/mountain-gerlach.jpg",
  "slovenia": "/images/highlights/climbing-osp.jpg",
  "south-africa": "/images/countries/south-africa.jpg",
  "spain": "/images/highlights/climbing-siurana.jpg",
  "sweden": "/images/highlights/trail-kungsleden-abisko.jpg",
  "switzerland": "/images/countries/switzerland.jpg",
  "tanzania": "/images/countries/tanzania.jpg",
  "turkey": "/images/highlights/paragliding-oludeniz.jpg",
  "united-kingdom": "/images/highlights/climbing-peak-district.jpg",
  "united-states": "/images/countries/united-states.jpg"
};

/** Only used for SEO / share cards when no curated country photo exists. */
export const DEFAULT_COUNTRY_HERO = "/images/countries/_default-mountain.jpg";

/**
 * Curated landscape for a country, or null when unknown.
 * Returning null avoids showing an unrelated mountain photo on island /
 * territory pages (e.g. Tokelau).
 */
const SEED_PHOTOS = countryPhotos as Record<string, string>;

export function getCountryHero(slug?: string | null): string | null {
  if (!slug) return null;
  const key = slug.toLowerCase();
  return COUNTRY_HEROES[key] || SEED_PHOTOS[key] || null;
}

export function getCountryHeroOrDefault(slug?: string | null): string {
  return getCountryHero(slug) || DEFAULT_COUNTRY_HERO;
}
